import * as React from 'react';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { useSelector } from 'react-redux';
import { lookupsLoadingFinishedSelector } from 'store/lookups/selector';
import { Fabric, Pivot, PivotItem } from '@fluentui/react';
import { Textbausteine } from './Textbausteine';
import { Skontodefinitionen } from './Skontodefinitionen';
import { Produzenten } from './Produzenten';
import { Produktgruppen } from './Produktgruppen';
import { ErweiterteSuchen } from './ErweiterteSuche';
import { InteresseFuerProdukteList } from './InteresseFuerProdukte';
import { AraRegelungen } from './AraRegelungen';
import { ArtikelEigenschaften } from './ArtikelEigenschaften';
import { Branchen } from './Branchen';
import { Kontodefinitionen } from './Kontodefinitionen';
import { Maschinentypen } from './Maschinentypen';

const styles = mergeStyleSets({
    container: {
        width: '100%',
        height: '100%',
    },
    itemWrapper: {
        height: 'calc(100vh - 75px)',
    },
});

const pivotStyles = {
    itemContainer: {
        height: 'calc(100vh - 120px)',
    },
};

export const LookupsView: React.FC = () => {
    const lookupsLoadingFinished = useSelector(lookupsLoadingFinishedSelector);
    const [subPage, setSubPage] = React.useState('textbausteine');

    if (!lookupsLoadingFinished) {
        return null;
    }

    return (
        <Fabric className={styles.container}>
            <Pivot
                styles={pivotStyles}
                selectedKey={subPage}
                onLinkClick={(item) => {
                    setSubPage(item?.props.itemKey || '');
                }}
            >
                <PivotItem itemKey="textbausteine" headerText="Textbausteine" className={styles.itemWrapper}>
                    <Textbausteine />
                </PivotItem>
                <PivotItem itemKey="skontodefinitionen" headerText="Skontodefinitionen" className={styles.itemWrapper}>
                    <Skontodefinitionen />
                </PivotItem>
                <PivotItem itemKey="kontodefinitionen" headerText="Kontodefinitionen" className={styles.itemWrapper}>
                    <Kontodefinitionen />
                </PivotItem>
                <PivotItem itemKey="produzenten" headerText="Produzenten" className={styles.itemWrapper}>
                    <Produzenten />
                </PivotItem>
                <PivotItem itemKey="produktgruppen" headerText="Produktgruppen" className={styles.itemWrapper}>
                    <Produktgruppen />
                </PivotItem>
                <PivotItem itemKey="erweitertesuchen" headerText="Erweiterte Suchen" className={styles.itemWrapper}>
                    <ErweiterteSuchen />
                </PivotItem>
                <PivotItem
                    itemKey="interessefuerprodukte"
                    headerText="Interesse für Produkte"
                    className={styles.itemWrapper}
                >
                    <InteresseFuerProdukteList />
                </PivotItem>
                <PivotItem itemKey="araregelungen" headerText="ARA Regelungen" className={styles.itemWrapper}>
                    <AraRegelungen />
                </PivotItem>
                <PivotItem
                    itemKey="artikeleigenschaften"
                    headerText="Artikeleigenschaften"
                    className={styles.itemWrapper}
                >
                    <ArtikelEigenschaften />
                </PivotItem>
                <PivotItem itemKey="branchen" headerText="Branchen" className={styles.itemWrapper}>
                    <Branchen />
                </PivotItem>
                <PivotItem itemKey="maschinentypen" headerText="Maschinentypen" className={styles.itemWrapper}>
                    <Maschinentypen />
                </PivotItem>
            </Pivot>
        </Fabric>
    );
};
